import type { InjectionKey, Ref } from 'vue';

export interface AccordionContext {
  readonly multiple: Ref<boolean>;
  readonly isOpen: (id: string) => boolean;
  readonly toggle: (id: string) => void;
}

export const ACCORDION_KEY: InjectionKey<AccordionContext> = Symbol('bafsy.accordion');
